import * as common from '@/store/common/mutation-types';
export default {
	...common,
	SET: 'SET',
	SET_SEARCH_PARAM: 'SET_SEARCH_PARAM'
};
